module.exports = __webpack_public_path__ + "img/sql.a5edbfce.svg";